<template>
  <VueHorizontalList
    :items="photos"
    :options="{
      responsive: [
        { end: 576, size: 1 },
        { start: 576, end: 768, size: 2 },
        { size: 3 },
      ],
    }"
  >
    <template v-slot:default="{ item }">
      <div class="item pr-5 pl-3">
        <img class="img-fluid mt-3" :src="item.photo" />
        <img
          v-if="item.photo === ''"
          class="img-fluid mt-3"
          :src="getImage(item.default)"
        />
        <p v-html="item.descrip" class="mt-2"></p>
        <span class="btn btn-outline-primary btn-file btn-rounded mt-1">
          <i class="fas fa-camera"></i> Tomar fotografía
          <input
            type="file"
            class="form-control"
            @change="onFileChange($event, item)"
            capture
            required
          />
        </span>
      </div>
    </template>
  </VueHorizontalList>
</template>
<script>
import VueHorizontalList from "vue-horizontal-list";

export default {
  components: {
    VueHorizontalList,
  },
  props: {
    photos: Array,
    onFileChange: Function
  },
  methods: {
    getImage(image) {
        return require(`./../assets/images/inspeccion/${image}`);
    }
  }
};
</script>
